import { render, staticRenderFns } from "./orderlist.vue?vue&type=template&id=8c75397e&scoped=true"
import script from "./orderlist.vue?vue&type=script&lang=ts"
export * from "./orderlist.vue?vue&type=script&lang=ts"
import style0 from "./orderlist.vue?vue&type=style&index=0&id=8c75397e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c75397e",
  null
  
)

export default component.exports